import * as TemplateTypes from 'types/template.types';
import BaseScene from 'src/scenes/base';

export default class FadeSceneTransition extends TemplateTypes.SceneTransition {
    private enterTween?: Phaser.Tweens.Tween;
    private exitTween?: Phaser.Tweens.Tween;

    constructor(scene: BaseScene, config: TemplateTypes.BaseTransitionConfig = {}){
        super(scene, config);
    }

    get isPlaying(){
        return this.exitTween?.isPlaying || this.enterTween?.isPlaying;
    }

    enter(onComplete?: Function) : Promise<void> | undefined {
        if (this.isPlaying) return;
        return new Promise((res, rej) => {
            this.scene.cameras.main.fadeIn(this.config.duration ?? 500, 0, 0, 0, (cam: Phaser.Cameras.Scene2D.Camera, progress: number) => {
                if (progress === 1){
                    onComplete?.();
                    res();
                }
            })
        })
    }

    exit(onComplete?: Function) : Promise<void> | undefined {
        if (this.isPlaying) return;
        return new Promise((res, rej) => {
            this.scene.cameras.main.fadeOut(this.config.duration ?? 500, 0, 0, 0, (cam: Phaser.Cameras.Scene2D.Camera, progress: number) => {
                if (progress === 1){
                    onComplete?.();
                    res();
                }
            })
        })
    }

    cancel(){
        this.enterTween?.stop();
        this.exitTween?.stop();
    }

    destroy(){
        this.enterTween?.destroy();
        this.exitTween?.destroy();
    }
}
